import Vue from 'vue';
import Router from 'vue-router';
import chatIndex from '@/views/index/index';
import newChat from '@/views/chat/chat';
import xiaoI from '@/views/xiaoI/chat';
/* eslint-disable */

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: newChat,
      meta: {keepalive: true}
    },
    {
      path: '/chatIndex',
      name: 'chatIndex',
      component: chatIndex,
      meta: {keepalive: true}
    }, {
        path: '/newChat',
        name: 'newChat',
        component: newChat,
        meta: {keepalive: true}
    }, {
        path: '/xiaoI',
        name: 'xiaoI',
        component: xiaoI,
        meta: {keepalive: true}
    }
  ]
})

// router.beforeEach((to, from, next) => {
//     if (to.path === '/newChat' && to.query.platform !== 'wechat') {
//         next({ path: '/xiaoI', query: to.query })
//     } else {
//         next();
//     }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js